import { render, staticRenderFns } from "./sportage-imgs-swiper.vue?vue&type=template&id=5d6b6711&scoped=true&"
import script from "./sportage-imgs-swiper.vue?vue&type=script&lang=js&"
export * from "./sportage-imgs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./sportage-imgs-swiper.vue?vue&type=style&index=0&id=5d6b6711&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b6711",
  null
  
)

export default component.exports